export default {
  noResults: 'No results for' ,
  searchPlaceholder: 'Search by name, email and number.' 
}